import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=b61222e2&"
import script from "./ProjectMembers.vue?vue&type=script&lang=ts&"
export * from "./ProjectMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports